<template>
    <div class="container-fluid">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- General -->
        <div class="row my-5">
            <div class="col-12">
                <form>
                    <div class="form-group"> 
                        <label for="visible">
                            <input v-model="showItems" class="mr-1" type="radio" name="visibility" id="visible" value="true" checked> 
                            Make my shop visible for all to see and buy from me
                        </label> 
                    </div>
                    <div class="form-group">
                        <label for="invinsible">
                            <input v-model="showItems" class="mr-1" type="radio" name="visibility" id="invinsible" value="false"> 
                            Make my shop invisible for all not to see and not buy from me
                        </label>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label for="openDonation">
                            <input v-model="showDonations" class="mr-1" type="radio" name="donations" id="openDonation" value="true" checked> 
                            Make my donations visible for all to see and benefit from me
                        </label> 
                    </div>
                    <div class="form-group">
                        <label for="closeDonation">
                            <input v-model="showDonations" class="mr-1" type="radio" name="donations" id="closeDonation" value="false"> 
                            Make my donations invisible for all not to see and not benefit from me
                        </label>
                    </div>
                    <hr>
                    <template v-if="myShop">
                        <p class="mt-4 mb-2">Modify Business Name</p>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text bg-light text-dark-green"><i class="fas fa-store"></i></div>
                            </div>
                            <input v-model="newShopName" ref="newShopName" type="text" class="form-control no-lines bg-white col-sm-6 col-12" :placeholder="myShop.shopName">
                        </div>
                        <button @click.prevent="editShopFxn" class="loadn btn btn-dark-green mt-4">Save Changes</button>
                    </template>
                </form>
            </div>
        </div>    
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "General",
    data() {
        return {
            newShopName: '',
            showItems: '',
            showDonations: '',
            msg: '',
            color: 'danger',
        }
    },
    methods: {
        ...mapActions(['editShop']),
        editShopFxn() {
            let shopObj = {
                userId: this.user._id,
                shopId: this.userShop._id,
                newShopName: this.newShopName,
                showItems: this.showItems,
                showDonations: this.showDonations
            }
            this.editShop(shopObj)
            .then((data) => {
                this.color = !data.error ? "success" : "danger",
                this.msg = data.msg
            })
        }
    },
    computed: {
        ...mapGetters(['user', 'userShop']),
        myShop() {
            if(this.userShop && this.userShop !== null){
                this.showItems = this.userShop.showItems
                this.showDonations = this.userShop.showDonations
                return this.userShop
            }
            return false
        },
    },
    mounted() {
        this.$router.push('?general').catch((e) => {})
    }
}
</script>